import { useContext } from 'react'
import ReservationFormContext from '../context/ReservationFormProvider';


const useReservationForm = () => {
    return useContext(ReservationFormContext);
}

export default useReservationForm